const AUTH_TOKEN_KEY = "token";

export function getAccessToken() {
  if (typeof window !== "undefined") {
    return localStorage.getItem(AUTH_TOKEN_KEY);
  }
}

export function setAccessToken(token) {
  if (typeof window !== "undefined" && token) {
    localStorage.setItem(AUTH_TOKEN_KEY, token);
  }
}

export function clearAuthState() {
  if (typeof window !== "undefined") {
    localStorage.removeItem(AUTH_TOKEN_KEY);
    localStorage.removeItem("login");
    localStorage.removeItem("pessoa");
  }
}
